import { useQuery } from "@tanstack/react-query";
import type { StockBalanceId, StoreId } from "@KassaroAB/shared/types/ids";
import { getCostPoolApi } from "../api/costPoolsApi";

export const useGetCostPoolQuery = (
  storeId: StoreId | null,
  pool: { poolKey: string; skuKey: StockBalanceId } | null,
) =>
  useQuery({
    queryKey: [
      "stores",
      storeId,
      "inventoryCosting",
      "pools",
      pool?.poolKey,
      pool?.skuKey,
    ],
    queryFn: () => getCostPoolApi(storeId!, pool!.poolKey, pool!.skuKey),
    enabled: !!storeId && !!pool,
  });
